import LinkedInPostAuth from './LinkedInPostAuth';

export default LinkedInPostAuth;
